<template>
  <a-modal
    :title="isEdit ? $t('page_console_notification_rule_edit') : $t('page_console_notification_rule_add')"
    :visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    :width="600"
    @cancel="handleCancel"
  >
    <a-form-model
      :model="form"
      ref="form"
      :rules="rules"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 17 }"
    >
      <a-form-model-item :label="$t('page_console_notification_rule_sort')" prop="sort">
        <a-input-number v-model="form.sort" style="width: 100%" />
      </a-form-model-item>
      <!--工作状态-->
      <a-form-model-item v-if="dictKey === 'work-record-status-change'"
                         :label="$t('page_console_notification_rule_work_status')" prop="notificationName">
        <a-select
                show-search
                :filter-option="filterOption"
                :placeholder="$t('please_select') + $t('page_console_notification_rule_work_status')"
                v-model="form.notificationName">
          <a-select-option
                  :value="item.value"
                  v-for="(item, index) in workStatusList"
                  :key="index"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <!--通知名称-->
      <a-form-model-item v-else :label="$t('page_console_notification_rule_notification_name')" prop="notificationName">
        <a-select
        show-search
        :filter-option="filterOption"
        :placeholder="$t('please_select') + $t('page_console_notification_rule_notification_name')"
        v-model="form.notificationName">
          <a-select-option
            :value="item.value"
            v-for="(item, index) in workStatusList"
            :key="index"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <!--设备状态通知规则 展示以下项-->
      <template v-if="dictKey ==='device-state-notify'">
        <!--首次触发条件-->
        <a-form-model-item
                :label="$t('page_console_notification_rule_first') + $t('page_console_notification_rule_triggering_conditions')"
                prop="firstTriggerCondition">
          <a-input-number
                  v-model="form.firstTriggerCondition"
                  type="number"
                  style="width: 300px; margin-right: 5px"
          />
          {{$t('minutes')}}
        </a-form-model-item>
        <!--递增条件-->
        <a-form-model-item :label="$t('page_console_notification_rule_increasing_condition')" prop="incrementCondition">
          <a-input-number
                  v-model="form.incrementCondition"
                  type="number"
                  style="width: 300px; margin-right: 5px"
          />
          {{$t('minutes')}}
        </a-form-model-item>
        <!--上限次数-->
        <a-form-model-item :label="$t('page_console_notification_rule_send_toplimit')" prop="sendNumberLimit">
          <a-input-number
                  v-model="form.sendNumberLimit"
                  type="number"
                  style="width: 300px; margin-right: 5px"
          />
          {{$t('page_console_notification_rule_times')}}
        </a-form-model-item>
      </template>

      <a-form-model-item v-if="dictKey !== 'work-record-status-change'" :label="$t('page_console_notification_rule_notification_time_range')" prop="notificationTimeRange">
        <a-select
        show-search
        :filter-option="filterOption"
        :placeholder="$t('please_select') + $t('page_console_notification_rule_notification_time_range')"
        v-model="form.notificationTimeRange">
          <a-select-option
            :value="item.value"
            v-for="(item, index) in timeRange"
            :key="index"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
        <div v-if="form.notificationTimeRange==2">
          <a-time-picker format="HH:mm:ss" valueFormat="HH:mm:ss" v-model="form.startTime" @change="changeTime"/> ~ <a-time-picker format="HH:mm:ss" valueFormat="HH:mm:ss" v-model="form.endTime" @change="changeTime"/>
        </div>
      </a-form-model-item>
      <a-form-model-item :label="$t('page_console_notification_rule_isEnable')" prop="isEnable">
        <a-radio-group v-model="form.isEnable">
          <a-radio :value="1"> {{$t('yes')}} </a-radio>
          <a-radio :value="0"> {{$t('no')}} </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item :label="$t('page_console_notification_rule_notification_user')" prop="notificationUserId">
        <a-select
          v-model="form.notificationUserId"
          :placeholder="$t('please_select') + $t('page_console_notification_rule_notification_user')"
          allowClear
          mode="multiple"
        >
          <a-select-option
            :value="item.id"
            v-for="(item, index) in userList"
            :key="index"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <!--工位产量超差预警-->
      <a-row v-if="dictKey ==='over-flow-warning'">
        <a-col span="24" style="text-align: center;color: #D9001B;">{{ $t('page_console_notification_rule_overflow_warning_tip') }}</a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import { MessageNotificationRulesServiceProxy } from "@/service-proxies/app-v2/notify.service-proxies";
import { EmployeeServiceProxy } from "@/service-proxies/app-v2/employee.service-proxies";
import { MasterlinkUserServiceProxy } from "@/service-proxies/app-v2/user.service-proxies";
import { DictBizServiceProxy, DictServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";
const messageNotificationRulesServiceProxy =
  new MessageNotificationRulesServiceProxy();
const employeeServiceProxy = new EmployeeServiceProxy();
const dbsp = new DictBizServiceProxy();
const dsp = new DictServiceProxy();
const musp = new MasterlinkUserServiceProxy();

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    id: {},
    ruleId:{},
    dictKey: {
      type: String,
      default: ''
    }
  },
  computed:{
    notificationNames () {// 通知名称
      let basic = [
        {
          label: '设备等待',
          value: 1
        },
        {
          label: '离线',
          value: 2
        },
        {
          label: '网络断线',
          value: 3
        },
        {
          label: '报警状态',
          value: 4
        }
      ]
      if (this.dictKey === 'over-flow-warning') {
        return [...basic, { label: '工位产量超差预警', value: 5 }]
      } else {
        return basic
      }
    },
    timeRange() {  // 时间范围
      return [
        {
          label: this.$t('page_console_notification_rule_factory_calendar'),
          value: 1,
        },
        {
          label: this.$t('page_role_management_custom'),
          value: 2,
        }
      ]
    }
  },
  watch: {
    visible: function (newVal) {
      if (newVal && this.isEdit) {
        this.getDetail();
      }
    },
    dictKey(val) {
      if(val) {
        if(val==='work-record-status-change') {
          this.getWorkStatusList();
          this.getUsers();
        } else {
          this.getDictionaryTree()
          this.getUserList();
        }

      }
    }
  },
  methods: {
    // 获取工作记录状态
    async getWorkStatusList() {
      let res = await dbsp.dictionary(this.dictKey)
      this.workStatusList = res.data.map(item=>({
        label: item.dictValue,
        value: Number(item.dictKey)
      }))
    },
    async getDictionaryTree() {
      let res = await dsp.dictionary(this.dictKey)
      this.workStatusList = res.data.map(item=>({
        label: item.dictValue,
        value: Number(item.dictKey)
      }))
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getDetail() {
      if (!this.id) return;
      let type = this.dictKey === 'work-record-status-change' ? 2 : 1
      messageNotificationRulesServiceProxy
        .getMessageNotificationRules(this.id, type)
        .then((res) => {
          let data = res;
          if(data.notificationUserId){
            data.notificationUserId = data.notificationUserId.split(',')
          }
          this.form =  data;
        });
    },
    getUserList() {
      employeeServiceProxy
        .getPageEmployees(1, { statusList: [1] }, "", -1)
        .then((res) => {
          this.userList = res.records;
        });
    },
    async getUsers() {
      const res = await musp.pageHasEmail(1, '', '', -1)
      this.userList = res.data.records
    },
    handleOk() {
      let _this = this;
      console.log(_this.form)
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.handleSubmit();
        }
      });
    },
    handleSubmit(){
      this.confirmLoading = true;
      let data = {
        sort: this.form.sort,
        notificationName: this.form.notificationName,
        isEnable: this.form.isEnable,
        notificationTimeRange: this.form.notificationTimeRange,
        notificationUserId: this.form.notificationUserId.join()
      }
      if (this.dictKey !== 'over-flow-warning') {
        data = Object.assign(data, {
          firstTriggerCondition: this.form.firstTriggerCondition,
          incrementCondition: this.form.incrementCondition,
          sendNumberLimit: this.form.sendNumberLimit
        })
      }
      if(data.notificationTimeRange == 2){
        data.startTime = this.form.startTime;
        data.endTime = this.form.endTime;
      }
      if(this.form.id){
        data.id = this.form.id;
      }
      if(this.form.ruleId){
        data.ruleId = this.form.ruleId
      }else{
        data.ruleId = this.ruleId
      }
      let notificationUserName = [];
      let notificationUserCode = [];
      this.form.notificationUserId.forEach(id => {
        let findItem = this.userList.find(item => {
          return item.id == id
        })
        if(findItem){
          notificationUserName.push(findItem.name);
          notificationUserCode.push(findItem.code)
        }
      })
      data.notificationUserName = notificationUserName.join();
      data.notificationUserCode = notificationUserCode.join();
      data.dictKey = this.dictKey
      messageNotificationRulesServiceProxy.submit(data).then(res => {
        this.confirmLoading = false;
        if(this.isEdit){
          this.$message.success(this.$t('page_console_notification_rule_edit_success'))
        }else{
          this.$message.success(this.$t('page_console_notification_rule_add_success'))
        }
        this.$emit('success');
        this.resetData();
      }).catch(() => {
        this.confirmLoading = false;
      })
    },
    handleCancel() {
      this.$emit("cancel", false);
      this.resetData();
    },
    changeTime(){
      this.$refs.form.validateField('notificationTimeRange');
    },
    resetData(){
      this.$refs.form.resetFields()
      this.form = {
        isEnable: 1,
        notificationUserId:[]
      };
    }
  },
  data() {
    let checkNotificationTimeRange = (rule, value, callback) => {
      if (value === undefined) {
        callback(new Error(this.$t('please_select')));
      } else {
        if (value === 2) {
          if(!this.form.startTime || !this.form.endTime){
            callback(new Error(this.$t('page_console_notification_rule_please_select_time')));
          }else{
            this.$refs.form.validateField('notificationTimeRange');
          }
        }
        callback();
      }
    };

    return {
      confirmLoading: false,
      userList: [], // 人员
      form: {
        isEnable: 1,
      },
      rules: {
        sort: [{ required: true, message: this.$t('common_please_input'), trigger: "blur" }],
        notificationName: [
          { required: true, message: this.$t('please_select'), trigger: "change" },
        ],
        firstTriggerCondition: [
          { required: true, message: this.$t('common_please_input'), trigger: "blur" },
        ],
        incrementCondition: [{ required: true, message: this.$t('common_please_input'), trigger: "blur" }],
        sendNumberLimit: [
          { required: true, message: this.$t('common_please_input'), trigger: "blur" },
        ],
        notificationTimeRange: [
          { required: true, message: this.$t('please_select'), trigger: "change" },
          { validator: checkNotificationTimeRange, trigger: 'change' },
        ],
        isEnable: [
          {
            required: true,
            message: this.$t('please_select'),
            trigger: "change",
          },
        ],
        notificationUserId: [
          { required: true, type:'array', message: this.$t('please_select'), trigger: "change" },
        ],
      },
      workStatusList: []
    };
  },
};
</script>

<style lang="less" scoped>
.deviceGroup {
  max-height: 150px;
  overflow-y: auto;
  border: 1px solid #d9d9d9;
  padding: 4px 11px;
}
</style>
